export const CREATE_PERMISSION = 'providers/AccessManagementPermission/CREATE_PERMISSION';
export const EDIT_PERMISSION = 'providers/AccessManagementPermission/EDIT_PERMISSION';
export const DELETE_PERMISSION = 'providers/AccessManagementPermission/DELETE_PERMISSION';
